"use strict";
(self["webpackChunkpop_and_bottle"] = self["webpackChunkpop_and_bottle"] || []).push([[13],{

/***/ 13:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ subscribeOptions)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utilities_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(363);
/* harmony import */ var prettier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891);
/* harmony import */ var prettier__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prettier__WEBPACK_IMPORTED_MODULE_2__);
// components/subscribe-options.js




function subscribeOptions({ wrapper }){
  console.log({
    message: 'init subscribe options js',
    wrapper
  });

  let settings = {
    subscribeOptionWrapper: '[data-subscribe-options]',
    deliveryOption: '[name="delivery_option"]',
    sellingPlanGroup: '[data-selling-plan-group]',
    sellingPlan: '[name="selling_plan"]',
    reChargeWidget: '.rc_widget[data-widget]',
    oneTimePrice: '[data-hook="one-time-price"]',
    oneTimeCompareAtPrice: '[data-hook="one-time-compare-at-price"]',
    subscribePrice: '[data-hook="subscribe-price"]',
    subscribeComparePrice: '[data-hook="subscribe-compare-at-price"]'
  }

  const cache = {
    $deliveryOption: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.deliveryOption),
    $sellingPlanGroup: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.sellingPlanGroup),
    $sellingPlan: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.sellingPlan),
    $oneTimePrice: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.oneTimePrice),
    $oneTimeCompareAtPrice: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.oneTimeCompareAtPrice),
    $subscribePrice: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.subscribePrice),
    $subscribeComparePrice: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.subscribeComparePrice)
  }

  const initEventListeners = function(){
    cache.$deliveryOption.on('change', handleDeliveryChange);
    removeReChargeWidgets();
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('variant-selector:change', handleVariantChange);
  }

  const handleVariantChange = function(e, {variant}){
    // update one time, subscribe price displays
    cache.$oneTimePrice.text((0,_utilities_functions__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variant.price));
    if (variant.selling_plan_allocations && variant.selling_plan_allocations[0]) {
      cache.$subscribePrice.text((0,_utilities_functions__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variant.selling_plan_allocations[0].price));
    }
    if(variant.compare_at_price > variant.price){
      cache.$oneTimeCompareAtPrice.text((0,_utilities_functions__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variant.compare_at_price));
    }
    else { 
      cache.$oneTimeCompareAtPrice.text(''); 
    }
    if (variant.selling_plan_allocations && variant.selling_plan_allocations[0]) {
      if (variant.selling_plan_allocations[0].compare_at_price > variant.selling_plan_allocations[0].price) {
        cache.$subscribeComparePrice.text((0,_utilities_functions__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(variant.selling_plan_allocations[0].compare_at_price));
      } else {
        cache.$subscribeComparePrice.text('');
      }
    }

//    console.log(variant);
  }

  const handleDeliveryChange = function(e,){
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
    // get closest parent of .tw-group from this
    const $group = $this.closest('.tw-group')
    // get the data attribute value of the element within $group that has data attribute data-sub-percent-off
    const data_percent_off = $group.find('[data-percent-off]').data('percent-off');
    // if dta_percent_off is 0, we need to reverse the price back to original price
    // if data_percent_off is not 0, we need to calculate the new price
    const elementsPricerPerUnits = document.querySelectorAll('.price_per_serving');
    if (elementsPricerPerUnits) {
      elementsPricerPerUnits.forEach(element => {
        if (element.dataset) {
          const original_price = element.dataset.originalPrice; 
          const number_of_units = element.dataset.numberOfUnits;
          const price_per_serving = original_price / number_of_units;
          if (data_percent_off == 0) {
            const formatted_price = (price_per_serving/100).toFixed(2);
            element.innerHTML = '$' + formatted_price;
          } else {
            const discounted_price = (price_per_serving/100) * (1 - data_percent_off/100);
            const formatted_price = discounted_price.toFixed(2);
            element.innerHTML = '$' + formatted_price;
          }
        }
      });
    }
    if ($this.val() === "subscribe") {
      // Expand the Frequency group
      cache.$sellingPlanGroup.slideDown(300)
      cache.$sellingPlan.prop('disabled', false)
    } else {
      cache.$sellingPlanGroup.slideUp(300)
      cache.$sellingPlan.prop('disabled', true)
    }
  }

  const removeReChargeWidgets = function(){
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).watchFor(settings.reChargeWidget, function($el){

//      console.log("watchFor ReCharge: ", $el)
      if (typeof ReChargeWidget  === "object") {
        ReChargeWidget.destroyAllWidgets()
      }
    })
  }

  initEventListeners()
}


/***/ })

}]);